import { useState } from 'react';
import ProjectModal from './ProjectModal';

const Portfolio = () => {
  const projects = [
    {
      id: 1,
      title: '夜桜 — Palace Hotel Tokyo',
      category: 'パーティ企画',
      year: '',
      image: 'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/df8496dcd03f9375d830d77f7adc05e2.png',
      size: 'wide',
      description: '皇居のお堀に映る桜をコンセプトに、五感を揺さぶる至高の空間を創造。世界中のセレブリティ300名が集う、一夜限りの夜桜プロデュース。',
      location: 'Palace Hotel Tokyo',
      guests: 'VIP 300名',
      details: [
        { label: '空間演出', content: '時間と共に移ろう「桜の色彩」を照明と音楽で表現' },
        { label: '食・飲', content: 'コンセプトを料理一皿、グラス一杯まで一貫させた特注メニュー' },
        { label: 'ギフト', content: 'ゲストの記憶に刻まれる、完全オーダーメイドの贈答品' },
        { label: '運営', content: '国内外のVIP 300名に対応するグローバル基準のホスピタリティ' },
      ],
      galleryImages: [
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/df8496dcd03f9375d830d77f7adc05e2.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/683e51107783c787fc2e8e46cdb20d8b.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/3829cc9b8916cd75f6226b587ec0c2ef.png',
      ],
    },
    {
      id: 2,
      title: 'THE ATTA TERRACE — OKINAWA',
      category: 'プライベートリトリート',
      year: '',
      image: 'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/e10deb9bae1d7fad03efc4dd4949f9de.jpeg',
      size: 'tall',
      description: '守られた空間が必須なセレブリティ70名のため、沖縄の広大な敷地をすべて「非日常の体験」に作り変えた「2泊3日の物語」。',
      location: 'THE ATTA TERRACE OKINAWA',
      guests: 'VIP 70名',
      details: [
        { label: '独占空間', content: 'ホテル全館バイアウトによる、秘匿性の高い完全プライベートな空間設計' },
        { label: '多彩なアクティビティ', content: '併設ゴルフ場でのコンペから、プールサイドでの屋外ライブまでを網羅' },
        { label: '24時間の体験デザイン', content: '夕景のレセプションから深夜のアフターパーティーまで、絶え間ない音楽と食の演出' },
        { label: 'トータル・ディレクション', content: '広大な敷地内での移動・進行・ホスピタリティをシームレスに統合' },
      ],
      galleryImages: [
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/e10deb9bae1d7fad03efc4dd4949f9de.jpeg',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/02942dd2d002c3169af9e89b2238b11e.jpeg',
      ],
    },
    {
      id: 3,
      title: 'チャリティーガラパーティー — Palace Hotel Tokyo',
      category: 'チャリティーイベント',
      year: '',
      image: 'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/4ba8ec672c73f5d09dc6005f64c29aaf.png',
      size: 'medium',
      description: 'パーティーに飽きた人々が最後に求めるのは、作り込まれた演出ではなく「本物」と「静寂」。1,000個の火が放つ熱量と香りは、デジタルでは再現できない圧倒的な体験をもたらしました。',
      location: 'Palace Hotel Tokyo',
      guests: '',
      details: [
        { label: '星降る夜の体験', content: '1,000個の灯火に託す、本質への回帰。作り込まれた演出ではなく「本物」と「静寂」を追求した空間。' },
        { label: '炎の演出', content: '1,000個の火が放つ熱量と香りは、デジタルでは再現できない圧倒的な体験をもたらしました。' },
      ],
      galleryImages: [
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/4ba8ec672c73f5d09dc6005f64c29aaf.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/89db6d2022bbb4fe1b8dd31cb7918842.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/81cf9c23b26f90d357b6c3a7f33a6bca.jpeg',
      ],
    },
    {
      id: 4,
      title: 'Luxury Brand Showcase',
      category: '展示会',
      year: '',
      image: 'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/dde2098f50f0c68b702d70cdd2b927b8.png',
      size: 'tall',
      description: 'ブランドの美学を空間で語る、エクスクルーシブな展示会。素材の輝き、音楽の鼓動、光の演出——すべてが一つの「美学」のもとに統合された、記憶に残るショーケース。',
      location: 'Palace Hotel Tokyo',
      guests: '',
      details: [
        { label: '空間設計', content: '会場の個性を活かし、ブランドの色に染め上げる舞台構築' },
        { label: '光の演出', content: '素材の質感やジュエリーの輝きを劇的に際立たせる照明' },
        { label: '音のデザイン', content: 'モデルの歩幅とゲストの鼓動を同期させる音楽セレクト' },
        { label: '統合監修', content: 'ヘアメイクから演出まで、すべての細部を一つの「美学」で統一' },
      ],
      galleryImages: [
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/dde2098f50f0c68b702d70cdd2b927b8.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/fee7bd58030a72639596495ac39ad708.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/c44cb4250a468fcf1fcc44f45c3a5270.jpeg',
      ],
    },
    {
      id: 5,
      title: 'SODOH HIGASHIYAMA — 京都',
      category: '文化体験',
      year: '',
      image: 'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/80fd9fcf1fb4d746ff22398f43ea82da.png',
      size: 'wide',
      description: '一般の観光では決して立ち入れない場所で、五感を研ぎ澄ます本物の日本体験をプロデュース。',
      location: 'SODOH HIGASHIYAMA',
      guests: '',
      details: [
        { label: '伝統の装い', content: '洗練された着物での立ち居振る舞いから始まる特別な一日' },
        { label: '深遠な茶道', content: '歴史ある空間で、季節の移ろいと静寂を味わう茶の湯の体験' },
        { label: '五感で味わう京都', content: '八坂の塔を望む邸宅にて、京野菜の繊細な食事と和菓子を堪能' },
        { label: 'アクセスの希少性', content: '格式高い歴史的建造物を貸し切り、プライベートな時間を提供' },
      ],
      galleryImages: [
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/80fd9fcf1fb4d746ff22398f43ea82da.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/7217aaa4340c279973f0bc635d52e9f8.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/47b5bac51eef6d9d1cc4dfceddaccf25.png',
      ],
    },
    {
      id: 6,
      title: '伝統芸能公演 — Palace Hotel Tokyo',
      category: '文化公演',
      year: '',
      image: 'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/af7f8543a3f9ce14385d33c2e8d9ed31.png',
      size: 'wide',
      description: '伝統を「鑑賞」するだけでなく、その精神性に「没入」する。海外VIPの審美眼を満足させる、最高峰の日本文化体験を提供します。',
      location: 'Palace Hotel Tokyo',
      guests: '',
      details: [
        { label: '家元による演舞', content: '家元の至近距離での演舞を軸に、日本の「陰影」と「音」で空間を研ぎ澄ませ、伝統の息遣いを五感で体感する特別な公演演出' },
      ],
      galleryImages: [
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/af7f8543a3f9ce14385d33c2e8d9ed31.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/3edbba6bf916958143c9a117339b3f95.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/b6eb56d93819513baf20a971f28c9267.png',
      ],
    },
    {
      id: 7,
      title: 'OKINAWA GANGARA — 沖縄',
      category: '企業イベント',
      year: '',
      image: 'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/73ebe89a6a4483b40b33c47e623a0e45.png',
      size: 'wide',
      description: '既存のパーティー会場では不可能な「驚き」と「感動」を提供し、社員と企業の絆を深める一生モノの思い出を創造しました。沖縄・ガンガラーの谷を舞台に、大自然の造形美と企業の祝祭を融合。旅行のハイライトとなる、圧倒的な没入体験をプロデュース。',
      location: 'OKINAWA GANGARA',
      guests: '',
      details: [],
      galleryImages: [
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/73ebe89a6a4483b40b33c47e623a0e45.png',
        'https://static.readdy.ai/image/bb898cd5bdd195ad57ef80276c72cdac/a72c6315b4d0f8802d14c6c25298a4b8.png',
      ],
    },
  ];

  const [selectedProject, setSelectedProject] = useState<typeof projects[0] | null>(null);

  return (
    <section id="portfolio" className="py-20 md:py-32" style={{ backgroundColor: '#FAF7F2' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* セクションヘッダー */}
        <div className="mb-16 md:mb-32">
          <div className="flex items-center space-x-4 mb-2">
            <div className="w-8 h-px bg-black"></div>
            <span className="text-2xl md:text-5xl tracking-[0.3em] text-gray-600 uppercase" style={{ fontWeight: 900 }}>Selected Works</span>
          </div>
          <div className="pl-12">
            <h2 className="font-extralight text-black tracking-tight" style={{ fontSize: 'clamp(0.85rem, 1.8vw, 1.35rem)' }}>
              実績
            </h2>
          </div>
          <p style={{ fontSize: 'clamp(0.88rem, 2.5vw, 1.35rem)', fontWeight: 400, color: '#6b7280', lineHeight: 1.8 }} className="mt-8 max-w-2xl leading-relaxed">
            私たちが手がけたパーティーと企画の空間デザインをご覧ください。
            それぞれが独自のストーリーを持った、記憶に残る体験空間です。
          </p>
        </div>

        {/* モバイル：縦並びカードリスト */}
        <div className="flex flex-col gap-3 md:hidden">
          {/* Project 1 */}
          <div className="w-full cursor-pointer group" onClick={() => setSelectedProject(projects[0])}>
            <div className="relative w-full h-[62vw] overflow-hidden bg-gray-100">
              <img src={projects[0].image} alt={projects[0].title} className="w-full h-full object-cover group-active:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-4 text-white">
                <p className="text-[10px] tracking-[0.2em] uppercase opacity-75 mb-0.5">{projects[0].location}</p>
                <p className="text-sm font-light tracking-wide">{projects[0].category}</p>
                <p className="text-xs font-semibold mt-0.5">{projects[0].title}</p>
              </div>
              <div className="absolute top-3 right-3">
                <span className="inline-flex items-center space-x-1 bg-white/90 text-black text-[9px] tracking-[0.2em] uppercase font-light px-2.5 py-1.5">
                  <span>詳細を見る</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 2 */}
          <div className="w-full cursor-pointer group" onClick={() => setSelectedProject(projects[1])}>
            <div className="relative w-full h-[48vw] overflow-hidden bg-gray-100">
              <img src={projects[1].image} alt={projects[1].title} className="w-full h-full object-cover group-active:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-4 text-white">
                <p className="text-[10px] tracking-[0.2em] uppercase opacity-75 mb-0.5 leading-snug">THE ATTA TERRACE<br />OKINAWA</p>
                <p className="text-sm font-light tracking-wide">{projects[1].category}</p>
                <p className="text-xs font-semibold mt-0.5">{projects[1].title}</p>
              </div>
              <div className="absolute top-3 right-3">
                <span className="inline-flex items-center space-x-1 bg-white/90 text-black text-[9px] tracking-[0.2em] uppercase font-light px-2.5 py-1.5">
                  <span>詳細を見る</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 3 & 4 — 2列並び */}
          <div className="grid grid-cols-2 gap-3">
            <div className="cursor-pointer group" onClick={() => setSelectedProject(projects[2])}>
              <div className="relative w-full h-[52vw] overflow-hidden bg-gray-100">
                <img src={projects[2].image} alt={projects[2].title} className="w-full h-full object-cover group-active:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-2.5 text-white">
                  <p className="text-[9px] tracking-[0.15em] uppercase opacity-75 mb-0.5 leading-tight">{projects[2].location}</p>
                  <p className="text-[11px] font-light">{projects[2].category}</p>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="inline-flex items-center bg-white/90 text-black text-[8px] tracking-[0.15em] uppercase font-light px-2 py-1">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="cursor-pointer group" onClick={() => setSelectedProject(projects[3])}>
              <div className="relative w-full h-[52vw] overflow-hidden bg-gray-100">
                <img src={projects[3].image} alt={projects[3].title} className="w-full h-full object-cover group-active:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-2.5 text-white">
                  <p className="text-[9px] tracking-[0.15em] uppercase opacity-75 mb-0.5 leading-tight">{projects[3].location}</p>
                  <p className="text-[11px] font-light">{projects[3].category}</p>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="inline-flex items-center bg-white/90 text-black text-[8px] tracking-[0.15em] uppercase font-light px-2 py-1">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Project 5 */}
          <div className="w-full cursor-pointer group" onClick={() => setSelectedProject(projects[4])}>
            <div className="relative w-full h-[62vw] overflow-hidden bg-gray-100">
              <img src={projects[4].image} alt={projects[4].title} className="w-full h-full object-cover group-active:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-4 text-white">
                <p className="text-[10px] tracking-[0.2em] uppercase opacity-75 mb-0.5">{projects[4].location}</p>
                <p className="text-sm font-light tracking-wide">{projects[4].category}</p>
                <p className="text-xs font-semibold mt-0.5">{projects[4].title}</p>
              </div>
              <div className="absolute top-3 right-3">
                <span className="inline-flex items-center space-x-1 bg-white/90 text-black text-[9px] tracking-[0.2em] uppercase font-light px-2.5 py-1.5">
                  <span>詳細を見る</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 6 & 7 — 2列並び */}
          <div className="grid grid-cols-2 gap-3">
            <div className="cursor-pointer group" onClick={() => setSelectedProject(projects[5])}>
              <div className="relative w-full h-[52vw] overflow-hidden bg-gray-100">
                <img src={projects[5].image} alt={projects[5].title} className="w-full h-full object-cover group-active:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-2.5 text-white">
                  <p className="text-[9px] tracking-[0.15em] uppercase opacity-75 mb-0.5 leading-tight">{projects[5].location}</p>
                  <p className="text-[11px] font-light">{projects[5].category}</p>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="inline-flex items-center bg-white/90 text-black text-[8px] tracking-[0.15em] uppercase font-light px-2 py-1">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="cursor-pointer group" onClick={() => setSelectedProject(projects[6])}>
              <div className="relative w-full h-[52vw] overflow-hidden bg-gray-100">
                <img src={projects[6].image} alt={projects[6].title} className="w-full h-full object-cover object-top group-active:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-2.5 text-white">
                  <p className="text-[9px] tracking-[0.15em] uppercase opacity-75 mb-0.5 leading-tight">{projects[6].location}</p>
                  <p className="text-[11px] font-light">{projects[6].category}</p>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="inline-flex items-center bg-white/90 text-black text-[8px] tracking-[0.15em] uppercase font-light px-2 py-1">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* デスクトップ：アーティスティックグリッドレイアウト */}
        <div className="hidden md:grid grid-cols-12 gap-4 auto-rows-[120px] max-w-5xl mx-auto">
          {/* Project 1 - 横長フォーマット */}
          <div className="col-span-7 row-span-3 group cursor-pointer" onClick={() => setSelectedProject(projects[0])}>
            <div className="relative h-full overflow-hidden bg-gray-100">
              <img src={projects[0].image} alt={projects[0].title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-700"></div>
              <div className="absolute top-0 left-0 p-6 flex flex-col items-start text-white">
                <p className="text-xl font-light tracking-[0.3em] uppercase mb-4">{projects[0].category}</p>
                <span className="inline-flex items-center space-x-2 bg-white/90 text-black text-xs tracking-[0.25em] uppercase font-light px-5 py-2.5 group-hover:bg-white transition-colors duration-300">
                  <span>詳細はこちら</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 2 - 縦長フォーマット */}
          <div className="col-span-5 row-span-4 group cursor-pointer" onClick={() => setSelectedProject(projects[1])}>
            <div className="relative h-full overflow-hidden bg-gray-100">
              <img src={projects[1].image} alt={projects[1].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-700"></div>
              <div className="absolute top-0 left-0 p-6 flex flex-col items-start text-white">
                <p className="text-xl font-light tracking-[0.3em] uppercase mb-4">{projects[1].category}</p>
                <span className="inline-flex items-center space-x-2 bg-white/90 text-black text-xs tracking-[0.25em] uppercase font-light px-5 py-2.5 group-hover:bg-white transition-colors duration-300">
                  <span>詳細はこちら</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 3 */}
          <div className="col-span-6 row-span-3 group cursor-pointer" onClick={() => setSelectedProject(projects[2])}>
            <div className="relative h-full overflow-hidden bg-gray-100">
              <img src={projects[2].image} alt={projects[2].title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-700"></div>
              <div className="absolute top-0 left-0 p-6 flex flex-col items-start text-white">
                <p className="text-xl font-light tracking-[0.3em] uppercase mb-4">{projects[2].category}</p>
                <span className="inline-flex items-center space-x-2 bg-white/90 text-black text-xs tracking-[0.25em] uppercase font-light px-5 py-2.5 group-hover:bg-white transition-colors duration-300">
                  <span>詳細はこちら</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 4 */}
          <div className="col-span-6 row-span-2 group cursor-pointer" onClick={() => setSelectedProject(projects[3])}>
            <div className="relative h-full overflow-hidden bg-gray-100">
              <img src={projects[3].image} alt={projects[3].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-700"></div>
              <div className="absolute top-0 left-0 p-6 flex flex-col items-start text-white">
                <p className="text-xl font-light tracking-[0.3em] uppercase mb-4">{projects[3].category}</p>
                <span className="inline-flex items-center space-x-2 bg-white/90 text-black text-xs tracking-[0.25em] uppercase font-light px-5 py-2.5 group-hover:bg-white transition-colors duration-300">
                  <span>詳細はこちら</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 5 */}
          <div className="col-span-7 row-span-3 group cursor-pointer" onClick={() => setSelectedProject(projects[4])}>
            <div className="relative h-full overflow-hidden bg-gray-100">
              <img src={projects[4].image} alt={projects[4].title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-700"></div>
              <div className="absolute top-0 left-0 p-6 flex flex-col items-start text-white">
                <p className="text-xl font-light tracking-[0.3em] uppercase mb-4">{projects[4].category}</p>
                <span className="inline-flex items-center space-x-2 bg-white/90 text-black text-xs tracking-[0.25em] uppercase font-light px-5 py-2.5 group-hover:bg-white transition-colors duration-300">
                  <span>詳細はこちら</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 6 */}
          <div className="col-span-5 row-span-3 group cursor-pointer" onClick={() => setSelectedProject(projects[5])}>
            <div className="relative h-full overflow-hidden bg-gray-100">
              <img src={projects[5].image} alt={projects[5].title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-700"></div>
              <div className="absolute top-0 left-0 p-6 flex flex-col items-start text-white">
                <p className="text-xl font-light tracking-[0.3em] uppercase mb-4">{projects[5].category}</p>
                <span className="inline-flex items-center space-x-2 bg-white/90 text-black text-xs tracking-[0.25em] uppercase font-light px-5 py-2.5 group-hover:bg-white transition-colors duration-300">
                  <span>詳細はこちら</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Project 7 */}
          <div className="col-span-12 row-span-2 group cursor-pointer" onClick={() => setSelectedProject(projects[6])}>
            <div className="relative h-full overflow-hidden bg-gray-100">
              <img src={projects[6].image} alt={projects[6].title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-1000" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-700"></div>
              <div className="absolute top-0 left-0 p-6 flex flex-col items-start text-white">
                <p className="text-xl font-light tracking-[0.3em] uppercase mb-4">{projects[6].category}</p>
                <span className="inline-flex items-center space-x-2 bg-white/90 text-black text-xs tracking-[0.25em] uppercase font-light px-5 py-2.5 group-hover:bg-white transition-colors duration-300">
                  <span>詳細はこちら</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* 装飾的な要素 */}
        <div className="mt-16 md:mt-32 flex items-center justify-center">
          <div className="flex items-center space-x-8">
            <div className="w-16 h-px bg-gray-300"></div>
            <span className="text-xs tracking-[0.3em] text-gray-400 uppercase">More Projects</span>
            <div className="w-16 h-px bg-gray-300"></div>
          </div>
        </div>
      </div>

      {/* Project Detail Modal */}
      <ProjectModal
        project={selectedProject}
        onClose={() => setSelectedProject(null)}
      />
    </section>
  );
};

export default Portfolio;
